import {
   GET_SENDER_DETAILS,
   GET_SENDER_DETAILS_BY_ID
  } from '../types'
  
  const INITIAL_STATE = {
    allSenderDetails: [],
    updateInsti: [],
    getOneSender: [],
  }
  
  const senderDetailsReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
      case GET_SENDER_DETAILS:
        return {
          ...state,
          allSenderDetails: payload.data,
          loader: false,
        }
      // case ADD_INSITITUTION:
      //   return {
      //     ...state,
      //     addInsti: payload,
      //   }
  
      // case UPDATE_INSTITUTION:
      //   return {
      //     ...state,
      //     updateInsti: payload.data,
      //     loader: false,
      //   }
  
      case GET_SENDER_DETAILS_BY_ID:
        return {
          ...state,
          getOneSender: payload.data,
        }
  
      default:
        return state
    }
  }
  
  export default senderDetailsReducer
  